import React from "react";
import Skeleton from "../components/skeleton/Dashboard";
import "../assets/css/room-panel.scss";
import ErrorHandler from "../class/ErrorHandler";
import commonMethod from "../lib/commonMethod";
import {connect} from "react-redux";
import cookie from "react-cookies";
import ArrowIcon from "../assets/img/setting/arrow";
import EnlargeIcon from "../assets/img/dashboard/enlarge";
import RecipeItem from "../components/dashboard/RecipeItem";
import DeviceItem from "../components/dashboard/DeviceItem";
import TimesIcon from "../assets/img/times";
import Refresh from "../components/Refresh";
import $ from "jquery";
import DeviceSetting from "../components/dashboard/DeviceSetting";
import RoomSetting from "../components/dashboard/RoomSetting";
import Paho from "paho-mqtt";
import {_setNewStatus} from "../components/dashboard/liveEvent";
import EditRoom from "../assets/img/dashboard/editRoom";

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            familyId: "",
            familyName: "",
            recipeList: [],
            roomList: [],
            room: "0",
            roomName: "ALL",
            deviceList: [],
            openRecipe: true,
            openDevice: true,
            refresh: false,
            isEnlarge: false,
            toggle: false,
            panelToggle: false,
            selectedItem: null,
            panelRoomToggle: false,
            edit: false,
            key: Math.random()
        }
        this.errorHandler = new ErrorHandler(this);
        this.accessToken = cookie.load('accessToken');
        this.handlePanelToggle = this.handlePanelToggle.bind(this)
        this.closePanelToggle = this.closePanelToggle.bind(this)
        this.getRoomList = this.getRoomList.bind(this);
        this.handleItemPower = this.handleItemPower.bind(this);
        this._onMessageArrived = this._onMessageArrived.bind(this);
        this._onConnectionLost = this._onConnectionLost.bind(this);
        this._initMqtt = this._initMqtt.bind(this);
        this.roomChange = this.roomChange.bind(this);
    }

    componentDidMount() {
        if (this.accessToken) {
            this._askforQueName();
        }
        this.getFamilyId();
        // 자동 새로고침
        let refreshTerm = cookie.load('refreshTerm');
        if (refreshTerm === "60") {
            setInterval(() => {
                this.setState({ refresh: true })
                this.getDeviceList(this.state.familyId, this.state.room);
                this.props.setIsRefresh(false)
            }, 60000);
        } else if (refreshTerm === "30") {
            setInterval(() => {
                this.setState({ refresh: true })
                this.getDeviceList(this.state.familyId, this.state.room);
                this.props.setIsRefresh(false)
            }, 30000);
        }
        $(window).scroll(function () {
            $('.top-select').css('left', -$(window).scrollLeft());
            $('.enlarge-wrap').css('left', -$(window).scrollLeft());
        });

        $('body').on('click', '.user-info-box .info-wrap .btn', function () {
            this._onDisconnect();
        });
    }

    componentDidUpdate(prevProp, prevState) {
        // 새로고침 버튼 클릭시 list 호출
        if (this.props.isRefresh && !this.state.edit) {
            this.setState({ refresh: true });
            this.getDeviceList(this.state.familyId, this.state.room);
            this.props.setIsRefresh(false)
        }
        if (this.props.isRefresh && this.state.edit) {
            let that = this;
            setTimeout(function () {
                that.setState({ refresh: true });
                that.getRoomList(that.state.familyId);
                that.props.setIsRefresh(false)
            },300)
            this.setState({
                edit: !this.state.edit
            })
        }
        // 전체화면 종료
        if (this.state.isEnlarge) {
            window.addEventListener('fullscreenchange', (e) => {
                if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
                    this.setState({ isEnlarge: false })
                    $('body').css('overflow-y', 'scroll')
                }
            });
        }
        if (this.state.selectedItem !== prevState.selectedItem) {
            this.setState((state,props)=>{
                return { selectedItem: state.selectedItem }
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState){
        if(nextState.loading === this.state.loading &&
            nextState.edit === this.state.edit &&
            nextState.panelRoomToggle === this.state.panelRoomToggle &&
            nextState.panelToggle === this.state.panelToggle &&
            nextState.familyId === this.state.familyId &&
            nextState.familyName === this.state.familyName &&
            nextState.deviceList === this.state.deviceList &&
            nextState.roomList === this.state.roomList &&
            nextState.openRecipe === this.state.openRecipe &&
            nextState.openDevice === this.state.openDevice &&
            nextState.refresh === this.state.refresh &&
            nextState.isEnlarge === this.state.isEnlarge &&
            nextState.toggle === this.state.toggle &&
            nextState.selectedItem === this.state.selectedItem &&
            nextState.recipeList === this.state.recipeList &&
            nextState.room === this.state.room &&
            nextState.roomName === this.state.roomName &&
            nextProps.isRefresh === this.props.isRefresh)
            return false
        return true
    }

    getFamilyId() {
      // familyId 값 get
      let url = window.location.href;
      let familyId = commonMethod.getQueryString('familyId') ?
          commonMethod.getQueryString('familyId') : cookie.load('familyId')
      if (familyId) this.setState({ familyId: familyId });
      this.getShopList(familyId)
    }

    getShopList(familyId) {
        // 제품 리스트 API 호출
        commonMethod.requestGetWithToken('dashboard/family', this.accessToken, this, res => {
            let shopList = res.result;
            let shopId = ""
            if (familyId) {
                shopList.findIndex(family => family.familyId === Number(familyId) &&
                this.setState({ familyName: family.name }));
                shopId = familyId;
            } else {
                this.setState({ familyId: shopList[0].familyId, familyName: shopList[0].name }); // 0번째
                shopId = shopList[0].familyId;
                cookie.save('familyId', shopList[0].familyId, {path:"/"});
            }
            this.setState({ familyId: shopId });
            this.getDeviceList(shopId, 0)
            this.getRecipe(shopId);
            this.getRoomList(shopId);
        });
    }

    getRoomList(familyId) {
        // 방 list 호출
        commonMethod.requestGetWithToken('dashboard/rooms/' + familyId, this.accessToken, this, res => {
            this.setState({ roomList: res.result.rooms })
        });
    }

    getDeviceList(familyId, roomId, callback = () => { }) {
        let roomIdNum = Number(roomId);
        let deviceList = [];

        if (roomId && roomIdNum !== 0) {
            // 방 선택 한 경우 해당 방 제품 API 호출
            commonMethod.requestGetWithToken('dashboard/' + familyId + '/room/' + roomIdNum + '/devices-state?scope=shop', this.accessToken, this, res => {
                // deviceList = res;
                this.setState((state,props)=>{
                    return { toggle: !state.toggle };
                })
                callback(true)
                this.setState({ loading: false, deviceList: res, refresh: false })
            });
        } else {
            // 전제 제품 API 호출 devices
            commonMethod.requestGetWithToken('dashboard/' + familyId + '/devices-state?scope=shop', this.accessToken, this, res => {
                // deviceList = res;
                this.setState((state,props)=>{
                    return { toggle: !state.toggle };
                })
                callback(true);
                this.setState({ loading: false, deviceList: res, refresh: false })
            });
        }
    }

    getRecipe(familyId) {
        // 레시피 list API 호출
        commonMethod.requestGetWithToken('dashboard/scene?family-id=' + familyId, this.accessToken, this, res => {
            this.setState({ recipeList: res.result });
        });
    }

    changeLocation(e) {
        // 상단 방 select 변경 이벤트
        const index = e.nativeEvent.target.selectedIndex;
        let name = e.nativeEvent.target[index].text
        this.setState({ room: e.target.value, roomName: name, refresh: true });
        this.getDeviceList(this.state.familyId, e.target.value);
    }

    toggleEnlarge(type) {
        // 전체화면 toggle 이벤트
        let elem = document.documentElement;
        if (type === 'zoomIn') {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) { /* Firefox */
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { /* IE/Edge */
                elem.msRequestFullscreen();
            }
            this.setState({ isEnlarge: true });
            $('body').css('overflow-y', 'hidden')
        } else if (type === "zoomOut") {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) { /* Firefox */
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE/Edge */
                document.msExitFullscreen();
            }
            this.setState({ isEnlarge: false });
            $('body').css('overflow-y', 'scroll')
        }
    }

    slideToggle(e, type) {
        // 레시피, 제품 리스트 slide
        if (type === "openDevice") {
            $('.device-list').slideToggle('200');
        } else {
            $('.recipe-list').slideToggle('200');
        }
        this.setState((state,props)=>{
            return { [type]: !state[type] }
        })
    }

    handlePanelToggle(item) {
        if (item.deviceState || item.deviceType.includes('Ir')) {
            // if (this.state.selectedItem !== item) {
                this.setState({ panelToggle: true, selectedItem: item, key: Math.random() });
                this.setState({ panelRoomToggle: false });
            // }
        } else {
            this.setState({ panelToggle: false, selectedItem: null });
        }
    }

    handlePanelRoomToggle() {
        this.setState({ panelRoomToggle: true });
    }

    handleItemPower(item) {
        this.setState({ key: Math.random() });
        this.setState({ selectedItem: item });
    }

    closePanelToggle(e) {
        e.preventDefault();
        const element = document.querySelectorAll('.device-item');
        const element2 = document.querySelector('.device-setting');
        const element3 = document.querySelector('.room-setting');
        const closePanel = document.querySelector('.close-panel');
        const editRoom = document.querySelector('.editRoom');
        let isChildren = false;
        let isButton = false;

        element.forEach(elem => {
            if (elem.contains(e.target)) isChildren = true;
        })
        if (editRoom && editRoom.contains(e.target)) isButton = true;

        if ((!isButton && !element3.contains(e.target)) || (closePanel && closePanel.contains(e.target))) {
            this.setState({ panelRoomToggle: false });
        }
        if ((!isChildren && !element2.contains(e.target)) || (closePanel && closePanel.contains(e.target))) {
            this.setState({ panelToggle: false, selectedItem: null });
        }
    }


    _askforQueName() {
        // const userName = this.props.userName;
        // const re = /\S+@\S+\.\S+/;
        // const isEmail = re.test(this.props.userName) ? "email" : "phone";
        this._initMqtt();
    }

    _initMqtt() {
        const wsbroker = "mqtt.hej.so";
        const wsport = window.location.protocol === "https:" ? 55002 : 15675; // port for above
        let client = new Paho.Client(wsbroker, Number(wsport), "/ws", "", 10);
        let loginId = cookie.load('username');
        if (loginId === "undefined" || loginId === undefined || loginId === null) {
            loginId = localStorage.getItem('username')
        }
        if (loginId.indexOf('.') !== -1) {
            loginId = loginId.replace(/\./gi, "-");
        }

        //eslint-disable-next-line
        if (loginId.indexOf('\%40') !== -1) {
            //eslint-disable-next-line
            loginId = loginId.replace(/\%40/gi, "@");
        }
        this.setState({ client })

        // 콜백 핸들러 설정
        client.onConnectionLost = this._onConnectionLost;
        client.onMessageArrived = this._onMessageArrived;
        const subscribeOptions = {
            qos: 1,  // QoS
            onSuccess: console.log,
            onFailure: console.log,
            timeout: 10
        };
        const options = {
            timeout: 3,
            keepAliveInterval: 30,
            onSuccess: function () {
                client.subscribe('custom.' + loginId + '.*', subscribeOptions);
            },
            onFailure: console.log,
            userName: '62f4020744ca4510827d3b4a4d2c7e7f',
            password: 'fcd4302cece447a9ab009296f649d2c0'
        };
        if (window.location.protocol === "https:") {
            options.useSSL = true;
        }
        client.connect(options);
    }

    // called when messages arrived
    _onMessageArrived(message) {
        let updateDeviceList = [...this.state.deviceList];
        const payloadString = JSON.parse(message.payloadString);
        let deepClone;
        let compare = true;
        if (payloadString.deviceDataReport) {
            updateDeviceList.forEach(device => {
                if (device.id === payloadString.deviceDataReport.devId) {
                    deepClone = _setNewStatus(device, payloadString.deviceDataReport.status);
                    device = JSON.parse(JSON.stringify(deepClone));
                }
            })
            this.setState({ deviceList: updateDeviceList });

            if (this.state.selectedItem !== null) {
                compare = this.state.selectedItem.deviceState && deepClone.deviceState ? this.isEqual(this.state.selectedItem.deviceState, deepClone.deviceState) : false;
            }

            if (!compare && this.state.selectedItem && this.state.selectedItem.id === payloadString.deviceDataReport.devId) {
                let deviceState = deepClone.deviceState;
                this.setState({
                    key: Math.random(),
                    selectedItem: {
                        ...this.state.selectedItem,
                        deviceState,
                    }
                })

            }
        }
    }

    isEqual(obj1, obj2) {
        const obj1Keys = Object.keys(obj1);
        const obj2Keys = Object.keys(obj2);
        if (obj1Keys.length !== obj2Keys.length) {
            return false;
        }
        for (let objKey of obj1Keys) {
            if (obj1[objKey] !== obj2[objKey]) {
                if (typeof obj1[objKey] == "object" && typeof obj2[objKey] == "object") {
                    if (!this.isEqual(obj1[objKey], obj2[objKey])) {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
        }
        return true;
    };

    // called when client lost connection
    _onConnectionLost(responseObject) {
        if (responseObject.errorCode !== 0) {
        }
        if (responseObject.errorCode === 5) {
            this._initMqtt();
        }

    }
    // called when disconnecting the client
    _onDisconnect() {
        this.state.client.disconnect();
    }

    roomChange(data) {
        this.setState({
            panelRoomToggle: !this.state.panelRoomToggle,
            edit: !this.state.edit,
        })
        this.props.setIsRefresh(true);
    }

    render() {
        let recipeList = this.state.recipeList;
        let deviceList = this.state.deviceList;
        let roomList = this.state.roomList;

        const devicesResolved = (deviceList || []).reduce((prev, curr) => {
          (curr.deviceType !== 'IrDiy' && !curr.deviceType.toLowerCase().includes("homecamera")) && prev.push(curr);
          return prev;
        }, []);

        try {
            return (
                <div
                    id="dashboard"
                    onClick={this.closePanelToggle}
                    className={this.state.isEnlarge ? "enlarge page" : "page"}
                >
                    {this.state.loading ?
                        <Skeleton />
                        :
                        <div
                            className={(this.state.panelToggle || this.state.panelRoomToggle) ? "dashboard-wrap open" : "dashboard-wrap "}
                            onClick={this.closePanelToggle}
                        >
                            <div className="top-select">
                                <span>대시보드</span>
                                <span className="bar">/</span>
                                <span className="family-name">{this.state.familyName}</span>
                                <span className="bar">/</span>
                                {this.state.isEnlarge &&
                                    <React.Fragment>
                                        <span>{this.state.roomName}</span>
                                        <span className="close-btn" onClick={() => this.toggleEnlarge('zoomOut')}><TimesIcon /></span>
                                    </React.Fragment>
                                }
                                <select onChange={(e) => this.changeLocation(e)}>
                                    <option value="0">ALL</option>
                                    {(roomList && roomList.length !== 0) && roomList.map((v, k) => {
                                        return (
                                            <option value={v.room_id} key={v.room_id}>
                                                {v.name}</option>
                                        )
                                    })}
                                </select>
                                <button
                                    onClick={() => this.handlePanelRoomToggle()}
                                    className={this.state.isEnlarge ? "hideEdit" : "editRoom"}
                                >
                                    <EditRoom />편집
                                </button>
                            </div>
                            <div className="enlarge-wrap">
                                <span
                                    className="enlarge-icon"
                                    onClick={() => this.toggleEnlarge('zoomIn')}
                                >
                                    <EnlargeIcon />
                                </span>
                            </div>
                            <div className="dashboard-wrap">
                                {/* 레시피 */}
                                <h3 onClick={(e) => this.slideToggle(e, "openRecipe")}
                                    className={this.state.openRecipe ? "open" : ""}>
                                    간편 레시피
                                    <ArrowIcon />
                                </h3>
                                <div className="div" />
                                <ul className="dashboard-list recipe-list">
                                    {(recipeList && recipeList.length !== 0) && recipeList.map((v, k) => {
                                        return (
                                            <RecipeItem
                                                item={v}
                                                key={v.sceneId}
                                                familyId={this.state.familyId}
                                                familyName={this.state.familyName}
                                                actionDevice={() => this.getDeviceList(this.state.familyId, this.state.room)}
                                            />
                                        )
                                    })}
                                </ul>
                                {/* 디바이스 */}
                                <h3 onClick={(e) => this.slideToggle(e, "openDevice")}
                                    className={this.state.openDevice ? "open" : ""}>
                                    디바이스
                                    <ArrowIcon />
                                </h3>
                                <div className="div" />
                                <ul className="dashboard-list device-list">
                                  {devicesResolved.map((device, index) => {
                                  return (
                                      <DeviceItem
                                          item={device}
                                          key={device.id + index}
                                          familyId={this.state.familyId}
                                          familyName={this.state.familyName}
                                          roomName={this.state.roomName}
                                          actionDevice={(callback) => this.getDeviceList(this.state.familyId, this.state.room, res => callback(res))}
                                          toggle={this.state.toggle}
                                          panelToggle={this.state.panelToggle}
                                          handlePanelToggle={this.handlePanelToggle}
                                          handleItemPower={this.handleItemPower}
                                          result={this.state.selectedItem && this.state.selectedItem.id && device.id && this.state.selectedItem.id === device.id}
                                      />
                                      )
                                  })}
                                </ul>
                            </div>
                            {/* 새로고침 */}
                            {this.state.refresh &&
                                <Refresh />
                            }
                        </div>
                    }
                    <div className={this.state.panelToggle ? "device-setting-wrap open" : "device-setting-wrap"}>
                        <DeviceSetting
                            key={this.state.key}
                            closePanel={this.closePanelToggle}
                            selectedItem={this.state.selectedItem}
                        />
                    </div>
                    <div className={this.state.panelRoomToggle ? "room-setting-wrap open" : "room-setting-wrap"}>
                        <RoomSetting
                            key={this.state.key + 1}
                            closePanel={this.closePanelToggle}
                            roomList={this.state.roomList}
                            panelRoomToggle={this.state.panelRoomToggle}
                            roomChange={this.roomChange}
                        />
                    </div>
                </div>
            )
        } catch (error) {
            this.errorHandler.processError(error);
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        accessToken: state.hejhome.accessToken,
        isRefresh: state.hejhome.isRefresh,
        navigationWidth: state.hejhome.navigationWidth,
    }
}

// dispatch - set
const mapDispatchToProps = dispatch => ({
    setAccessToken: (token) => dispatch({
        type: 'setAccessToken',
        accessToken: token,
    }),
    setIsRefresh: (bool) => dispatch({
        type: 'setIsRefresh',
        isRefresh: bool,
    }),
});

Dashboard = connect(mapStateToProps, mapDispatchToProps)(Dashboard);

export default Dashboard;
